// extracted by mini-css-extract-plugin
module.exports = {"divTextArea":"SendMessage_divTextArea__1z6Ek","textArea":"SendMessage_textArea__1etF4","thumbNail":"SendMessage_thumbNail__3g2E0"};